export default __webpack_public_path__ + "static/media/Gallery - Edition II vs IV - 2_02.c34fe4e8.jpg";